var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { Component } from 'react';
import { UlTag, LiTag } from '../../Utils/AtomicTag';
var SkeletonParagraph = /** @class */ (function (_super) {
    __extends(SkeletonParagraph, _super);
    function SkeletonParagraph(props) {
        return _super.call(this, props) || this;
    }
    SkeletonParagraph.prototype.render = function () {
        var _a = this.props, active = _a.active, rows = _a.rows, width = _a.width, rest = __rest(_a, ["active", "rows", "width"]);
        var paragraphClass = ['rounded-sm', 'w-full', 'h-px-24', 'mt-px-16'];
        var activeClassName = active ? 'active' : '';
        return (React.createElement(UlTag, __assign({ name: SkeletonParagraph.NAME, atomics: 'mt-px-24' }, rest), __spread(Array(rows).keys()).map(function (item, index) {
            if (index === rows - 1) {
                return (React.createElement(LiTag, { atomics: paragraphClass, className: "bg-gray " + activeClassName, style: { width: width }, key: index }));
            }
            else {
                return (React.createElement(LiTag, { atomics: paragraphClass, className: "bg-gray " + activeClassName, key: index }));
            }
        })));
    };
    SkeletonParagraph.NAME = 'skeleton-paragraph';
    SkeletonParagraph.displayName = 'SkeletonParagraph';
    return SkeletonParagraph;
}(Component));
export { SkeletonParagraph };
